<template style="background-color:white">
  <section class="init_box" style="background-color: white">
    <el-row type="flex" justify="end" style="flex-wrap: wrap; flex-direction: row">
      <el-col :span="24" style="margin-top: 15px; padding-left: 10px"></el-col>
    </el-row>
    <el-row style="margin-top: 0px; flex-wrap: wrap; flex-direction: row" type="flex" justify="end">
      <el-col :span="8" style="float: left; margin-top: 10px; white-space: nowrap; overflow: hidden;">
        <el-button type="primary" class="statueBtn" style="background-color: #909399"></el-button><span class="statueSpan"
          style="">草稿</span>
        <el-button type="primary" class="statueBtn" style="background-color: #2b85e4"></el-button><span class="statueSpan"
          style="">待审核</span>
        <el-button type="primary" class="statueBtn" style="background-color: green"></el-button><span class="statueSpan"
          style="">审核通过</span>
        <el-button type="primary" class="statueBtn" style="background-color: chocolate"></el-button><span
          class="statueSpan" style="">已出库</span>
        <el-button type="primary" class="statueBtn" style="background-color: #666666"></el-button><span
          class="statueSpan" style="">已结束</span>
        <el-button type="primary" class="statueBtn" style="background-color: #c0c4cc"></el-button><span
          class="statueSpan" style="">已撤回</span>
        <el-button type="primary" class="statueBtn" style="background-color: red"></el-button><span class="statueSpan"
          style="">不通过</span>
      </el-col>
      <!-- 搜索框 -->
      <el-col :span="16">
        <el-form :model="searchModel" :inline="true" style="float: right" @submit.native.prevent>
          <el-form-item label="项目名称">
            <el-input placeholder="请输入项目名称" v-model="searchModel.projectName" clearable style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="项目状态">
            <el-select placeholder="请选择项目状态" v-model="searchModel.status" clearable style="width: 150px">
              <el-option label="草稿" :value="4"></el-option>
              <el-option label="待审核" :value="0"></el-option>
              <el-option label="通过" :value="1"></el-option>
              <el-option label="已出库" :value="2"></el-option>
              <el-option label="已领用确认" :value="3"></el-option>
              <el-option label="已撤回" :value="5"></el-option>
              <el-option label="已结束" :value="8"></el-option>
              <el-option label="不通过" :value="9"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getList">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 数据展示表格 -->
      <el-col :span="24" style="margin-top: 5px">
        <el-table :data="dataList" ref="infoTable" id="infoTable" :header-cell-style="{ background: '#eff3f6' }" stripe
          :row-key="getRowKeys" style="
            width: 99%;
            margin: 0px auto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          " height="600">
          <el-table-column type="selection" width="55" :reserve-selection="true" style="border-color: black">
          </el-table-column>
          <el-table-column type="index" label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="deviceNames" label="资产名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" width="300" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="addressName" label="使用区域" width="200" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="getType" label="领用方式" width="100" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.getType == 1">自取</span>
              <span v-if="scope.row.getType == 2">邮寄</span>
              <span v-if="scope.row.getType == 3">委托他人</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="发起时间" width="160" align="center"
            :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="status" label="状态" width="120" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 4 || scope.row.status == '4'" style="color: #909399">草稿</span>
              <span v-else-if="scope.row.status == 0 || scope.row.status == '0'" style="color: #2b85e4">待审核</span>
              <span v-else-if="scope.row.status == 1 || scope.row.status == '1'" style="color: green">通过</span>
              <span v-else-if="scope.row.status == 2 || scope.row.status == '2'" style="color: chocolate">已出库</span>
              <span v-else-if="scope.row.status == 3 || scope.row.status == '3'" style="color: chocolate">已领用确认</span>
              <span v-else-if="scope.row.status == 5 || scope.row.status == '5'" style="color: #c0c4cc">已撤回</span>
              <span v-else-if="scope.row.status == 8 || scope.row.status == '8'" style="color: dimgray">已结束</span>
              <span v-else-if="scope.row.status == 9 || scope.row.status == '9'" style="color: red">不通过</span>
              <span v-else style="color: #999">未知状态 ({{ scope.row.status }})</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="280">
            <template slot-scope="scope">
              <el-button @click="selectClick(scope.row)" type="text" size="small">详情</el-button>
              <el-button @click="receiptConfirm(scope.row)" v-if="scope.row.status == '2' || scope.row.status == 2"
                type="text" size="small">领用确认</el-button>
              <!-- 草稿状态（"4"）：编辑/提交/删除 -->
              <template v-if="scope.row.status == 4 || scope.row.status == '4'">
                <el-button @click="editDraftBtn(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="submitDraftBtn(scope.row)" type="text" size="small"
                  style="color: #2b85e4">提交</el-button>
                <el-button @click="deleteDraftBtn(scope.row)" type="text" style="color: red" size="small">删除</el-button>
              </template>
              <!-- 待审核状态：撤回 -->
              <el-button
                v-if="scope.row.status == '0' || scope.row.status == 0"
                @click="cancelBorrowBtn(scope.row)" type="text" size="small" style="color: #e6a23c">撤回</el-button>
              <el-button @click="clickDeleteBtn(scope.row.id)" type="text" style="color: red"
                v-if="btnRole.indexOf('208') != -1 && (scope.row.status == '0' || scope.row.status == 0 || scope.row.status == '9' || scope.row.status == 9)"
                size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination v-if="total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" :current-page="pageIndex"
          layout="total, sizes, prev, pager, next, jumper" :total="total" style="float: right">
        </el-pagination>
      </el-col>
    </el-row>
    <!-- 购物车 -->
    <div style="
        position: fixed;
        top: 18%;
        left: 600px;
        height: 50px;
        width: 50px;
        font-size: 20px;
      " @click="checkBoxdialog = true" v-if="checkBoxData.length > 0">
      <!-- <i class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></i> -->
      <el-badge :value="checkBoxNumber">
        <!-- <span class="iconfont icon--task- " style="width:100%;height:100%;font-size: 40px"></span> -->
        <img src="../../../static/img/selects.png" style="width: 70%; height: 70%; font-size: 40px" />
      </el-badge>
    </div>
    <!-- 查看详细 -->
    <el-dialog :visible.sync="viewShow" title="查看详细" :close-on-click-modal="false" :close-on-press-escape="false"
      width="1200px">
      <el-form :model="viewForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left: 5%">
        <el-row>
          <el-col :span="24">
            <el-descriptions :column="2" border>
              <el-descriptions-item label="项目名称">{{
                viewForm.projectName
                }}</el-descriptions-item>
              <el-descriptions-item label="使用区域" :span="2">{{
                viewForm.addressName
                }}</el-descriptions-item>
              <el-descriptions-item label="详细地址">
                {{ viewForm.addressDetail }}
              </el-descriptions-item>
              <el-descriptions-item label="借用日期">{{ viewForm.borrowDateStart }} 至
                {{ viewForm.borrowDateEnd }}</el-descriptions-item>
              <el-descriptions-item label="领用方式">
                <span v-if="viewForm.getType == 1">自取</span>
                <span v-if="viewForm.getType == 2">邮寄</span>
                <span v-if="viewForm.getType == 3">委托他人</span>
              </el-descriptions-item>
              <el-descriptions-item label="邮寄地址" v-if="viewForm.getType == '2'">
                {{ viewForm.name }} {{ viewForm.phone }} {{ viewForm.address }}
              </el-descriptions-item>
              <el-descriptions-item label="委托人姓名" v-if="viewForm.getType == '3'">
                {{ viewForm.persion }}
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>
        <div>
          <div style="line-height: 40px; font-size: 14px; text-align: left">
            资产列表
          </div>
          <div>
            <el-table :data="viewForm.detailList" style="width: 100%; text-align: center" size="mini" max-height="235px"
              :header-cell-style="{
                textAlign: 'center',
                background: '#eff3f6',
              }" :cell-style="{ textAlign: 'center' }">
              <el-table-column prop="deviceinfo.glbh" label="管理编号" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="deviceinfo.zcbh" label="管理编号" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="deviceinfo.zcmc" label="资产名称" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="deviceinfo.sbxh" label="规格型号" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="status" label="在库情况" show-overflow-tooltip v-if="
                viewForm.status == '1' ||
                viewForm.status == '2' ||
                viewForm.status == '3'
              ">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0" style="color: green">在库</span>
                  <span v-else-if="scope.row.status == 1" style="color: chocolate">借出</span>
                  <span v-else-if="scope.row.status == 2" style="color: green">已归还</span>
                  <span v-else style="color: rgb(64, 149, 229)">--</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="调换状态" show-overflow-tooltip v-if="
                viewForm.status == '1' ||
                viewForm.status == '2' ||
                viewForm.status == '3'
              ">
                <template slot-scope="scope">
                  <span v-if="scope.row.exchangeStatus == '0'" style="color: green">--</span>
                  <span v-else-if="scope.row.exchangeStatus == '1'">调入</span>
                  <span v-else-if="scope.row.exchangeStatus == '2'" style="color: chocolate">调出</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="210">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 1 || scope.row.status == 2">
                    <el-button @click="viewLend(scope.row)" type="text" size="small">出入库记录</el-button>
                    <el-button @click="viewUsageRecord(scope.row)" type="text" size="small">使用记录</el-button>
                    <el-button @click="viewMaintenanceRecord(scope.row)" type="text" size="small">维护记录</el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 审核意见 -->
        <div v-if="viewForm.remark"
          style="margin-top: 20px; text-align: left; padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
          <div style="font-weight: bold; color: #606266; margin-bottom: 8px;">审核意见:</div>
          <div style="color: #909399; line-height: 1.6;">{{ viewForm.remark }}</div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button style="margin-left: 10px" type="info" @click="viewShow = false">关闭</el-button>
        <!-- <el-button style="margin-left: 10px;" v-if="viewForm.status == '0'" type="primary" @click="auditHandle">审核</el-button> -->
      </div>
    </el-dialog>

    <!-- 借还记录 -->
    <el-dialog :visible.sync="lendShow" title="借还记录" width="1000px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="出库人">{{
          lendForm.outUserText
          }}</el-descriptions-item>
        <el-descriptions-item label="出库时间">{{
          lendForm.outTime
          }}</el-descriptions-item>
        <el-descriptions-item label="出库照片" :span="2" v-if="lendForm.prePhotos">
          <el-image style="height: 100px" :src="getFullUrl(lendForm.prePhotos)"
            :preview-src-list="lendForm.prePhotoUrls"></el-image>
          <span style="margin-left: 10px">共{{
            lendForm.prePhotoUrls ? lendForm.prePhotoUrls.length : 0
          }}张</span>
        </el-descriptions-item>
        <el-descriptions-item label="出库备注" v-if="lendForm.remarkOut">
          {{ lendForm.remarkOut }}
        </el-descriptions-item>
        <el-descriptions-item label="入库人" v-if="lendForm.status == '2'">{{
          lendForm.inUserText
          }}</el-descriptions-item>
        <el-descriptions-item label="入库时间" v-if="lendForm.status == '2'">{{
          lendForm.inTime
          }}</el-descriptions-item>
        <el-descriptions-item label="入库照片" v-if="lendForm.status == '2' && lendForm.photoUrls">
          <el-image style="height: 100px" :src="getFullUrl(lendForm.photos)"
            :preview-src-list="lendForm.photoUrls"></el-image>
          <span style="margin-left: 10px">共{{ lendForm.photoUrls ? lendForm.photoUrls.length : 0 }}张</span>
        </el-descriptions-item>
        <el-descriptions-item label="入库签名" v-if="lendForm.status == '2' && lendForm.signPic">
          <el-image style="height: 100px" :src="getFullUrl(lendForm.signPic)"
            :preview-src-list="[getFullUrl(lendForm.signPic)]"></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="入库备注" v-if="lendForm.status == '2' && lendForm.remark">
          {{ lendForm.remark }}
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px" type="info" @click="lendShow = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 领用确认 -->
    <el-dialog :visible.sync="receiptShow" title="领用确认" width="900px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <ReceiptConfirm :receiptForm="receiptForm" @confirmOk="confirmOk"></ReceiptConfirm>
    </el-dialog>

    <!-- 使用记录 -->
    <el-dialog :visible.sync="usageRecordShow" title="使用记录" width="1200px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div style="margin-bottom: 15px; display: flex; justify-content: space-between;">
        <div>
          <el-button type="primary" size="small" @click="showAddUsageRecord">新增记录</el-button>
        </div>
        <div>
          <el-button type="success" size="small" @click="exportUsageRecord">导出</el-button>
        </div>
      </div>
      <el-table :data="usageRecordList" :header-cell-style="{ background: '#eff3f6' }" max-height="400"
        style="width: 100%">

        <el-table-column prop="useDate" label="使用日期" width="120" align="center"></el-table-column>
        <el-table-column prop="sampleName" label="样品名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sampleCode" label="样品编号" width="140" align="center"></el-table-column>
        <el-table-column label="开始时间" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.startTime ? scope.row.startTime.substring(0, 5) : '--' }}</template>
        </el-table-column>
        <el-table-column label="结束时间" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.endTime ? scope.row.endTime.substring(0, 5) : '--' }}</template>
        </el-table-column>
        <el-table-column prop="statusBeforeUse" label="使用前状态" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.statusBeforeUse == 1" style="color: green">正常</span>
            <span v-else-if="scope.row.statusBeforeUse == 2" style="color: red">异常</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusAfterUse" label="使用后状态" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.statusAfterUse == 1" style="color: green">正常</span>
            <span v-else-if="scope.row.statusAfterUse == 2" style="color: red">异常</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="usePerson" label="使用人" width="100" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button @click="deleteUsageRecord(scope.row.id)" type="text" size="small"
              style="color: red">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="usageRecordShow = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 新增使用记录 -->
    <el-dialog :visible.sync="addUsageRecordShow" title="新增使用记录" width="600px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form :model="usageRecordForm" ref="usageRecordFormRef" label-width="100px">
        <el-form-item label="使用日期" prop="useDate">
          <el-date-picker v-model="usageRecordForm.useDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择使用日期"
            style="width: 100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-time-picker v-model="usageRecordForm.startTime" format="HH:mm" value-format="HH:mm" placeholder="请选择开始时间"
            style="width: 100%"></el-time-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-time-picker v-model="usageRecordForm.endTime" format="HH:mm" value-format="HH:mm" placeholder="请选择结束时间"
            style="width: 100%"></el-time-picker>
        </el-form-item>
        <el-form-item label="样品名称" prop="sampleName">
          <el-input v-model="usageRecordForm.sampleName" placeholder="请输入样品名称"></el-input>
        </el-form-item>
        <el-form-item label="样品编号" prop="sampleCode">
          <el-input v-model="usageRecordForm.sampleCode" placeholder="请输入样品编号"></el-input>
        </el-form-item>
        <el-form-item label="使用前状态" prop="statusBeforeUse">
          <el-select v-model="usageRecordForm.statusBeforeUse" placeholder="请选择使用前状态" style="width: 100%">
            <el-option label="正常" :value="1"></el-option>
            <el-option label="异常" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用后状态" prop="statusAfterUse">
          <el-select v-model="usageRecordForm.statusAfterUse" placeholder="请选择使用后状态" style="width: 100%">
            <el-option label="正常" :value="1"></el-option>
            <el-option label="异常" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="usageRecordForm.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addUsageRecordShow = false">取消</el-button>
        <el-button type="primary" @click="submitUsageRecord">保存</el-button>
      </div>
    </el-dialog>

    <!-- 维护记录 -->
    <el-dialog :visible.sync="maintenanceRecordShow" title="维护记录" width="1100px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div style="margin-bottom: 15px; display: flex; justify-content: space-between;">
        <div>
          <el-button type="primary" size="small" @click="showAddMaintenanceRecord">新增记录</el-button>
        </div>
        <div>
          <span style="color: #909399; font-size: 12px;">设备：{{ maintenanceDeviceName }}</span>
          <el-button type="success" size="small" @click="exportMaintenanceRecord" style="margin-left: 10px;">导出</el-button>
        </div>
      </div>
      <el-table :data="maintenanceRecordList" :header-cell-style="{ background: '#eff3f6' }" max-height="400"
        style="width: 100%">
        <el-table-column prop="maintenanceTime" label="维护日期" width="120" align="center"></el-table-column>
        <el-table-column prop="maintenanceContent" label="维护内容" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column prop="maintenancePerson" label="维护人" width="100" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button @click="deleteMaintenanceRecord(scope.row.id)" type="text" size="small"
              style="color: red">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="maintenanceRecordShow = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 新增维护记录 -->
    <el-dialog :visible.sync="addMaintenanceRecordShow" title="新增维护记录" width="600px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form :model="maintenanceRecordForm" ref="maintenanceRecordFormRef" label-width="100px">
        <el-form-item label="维护日期" prop="maintenanceTime" required>
          <el-date-picker v-model="maintenanceRecordForm.maintenanceTime" type="date" value-format="yyyy-MM-dd"
            placeholder="请选择维护日期" style="width: 100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="维护内容" prop="maintenanceContent" required>
          <el-input v-model="maintenanceRecordForm.maintenanceContent" type="textarea" :rows="3"
            placeholder="请输入维护内容"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="maintenanceRecordForm.remark" type="textarea" :rows="2" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addMaintenanceRecordShow = false">取消</el-button>
        <el-button type="primary" @click="submitMaintenanceRecord">保存</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import DeviceinfoCard from "./Deviceinfo_card.vue";
import deviceinfoCardPL from "./Deviceinfo_cardPL.vue";
import MultipleDevices from "../../components/common/MultipleDevices.vue";
import ReceiptConfirm from "./components/ReceiptConfirm.vue";
import ReceiptExchange from "./components/ReceiptExchange.vue";
import {
  mktBorrowSelect,
  mktBorrowView,
  mktBorrowViewDetail,
  mktBorrowDelete,
  mktBorrowConfirmView,
  mktBorrowSubmit,
  mktBorrowCancel,
  mktBorrowUpdateDraft,
  mktBorrowDeleteDraft,
  mktUsageRecordListByBorrowId,
  mktUsageRecordAdd,
  mktUsageRecordDelete,
  mktUsageRecordExport,
  mktMaintenanceRecordListByDeviceId,
  mktMaintenanceRecordAdd,
  mktMaintenanceRecordDelete,
  mktMaintenanceRecordExport,
  base,
} from "../../api/api";
import WeibaoApplyVue from "../../components/common/WeibaoApply.vue";
import baoFeiApplyVue from "../../components/common/BaoFeiApply.vue";
import DeviceCardbg from "./deviceCardbg.vue";
const docxPre = require("docx-preview");
window.JSZip = require("jszip");
let id = 0;
export default {
  name: "Deviceinfo",
  components: {
    DeviceinfoCard,
    WeibaoApplyVue,
    baoFeiApplyVue,
    DeviceCardbg,
    deviceinfoCardPL,
    DC: MultipleDevices,
    ReceiptConfirm,
    ReceiptExchange,
  },
  data() {
    return {
      companyProps: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false,
      },
      props: {
        label: "deviceTypeName",
        value: "id",
        children: "deviceTypes",
        expandTrigger: "click",
        emitPath: false,
        checkStrictly: true, //设置可以单选一级
      },
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      dataList: [],
      checkList: [],
      btnRole: [],
      searchModel: {
        projectName: "",
        status: "",
      },
      companySelect: [],
      deviceTypeSelect: [],
      check: [],
      checkList: [],
      checkBoxData: [],
      viewShow: false,
      viewForm: {},

      lendShow: false,
      lendForm: {},
      returnShow: false,

      receiptShow: false,
      receiptForm: {},

      // 使用记录
      usageRecordShow: false,
      usageRecordList: [],
      usageRecordRow: {},
      addUsageRecordShow: false,
      usageRecordForm: {
        borrowId: null,
        deviceId: null,
        deviceCode: '',
        deviceName: '',
        useDate: '',
        startTime: '',
        endTime: '',
        sampleName: '',
        sampleCode: '',
        statusBeforeUse: null,
        statusAfterUse: null,
        remark: ''
      },

      // 维护记录
      maintenanceRecordShow: false,
      maintenanceRecordList: [],
      maintenanceRecordRow: {},
      maintenanceDeviceName: '',
      addMaintenanceRecordShow: false,
      maintenanceRecordForm: {
        borrowId: null,
        deviceId: null,
        maintenanceTime: '',
        maintenanceContent: '',
        remark: ''
      },
    };
  },
  methods: {
    // 获取完整图片URL
    getFullUrl(path) {
      if (!path) return ''
      if (path.startsWith('http://') || path.startsWith('https://')) {
        return path
      }
      return base + path
    },
    getList() {
      mktBorrowSelect({ pageIndex: this.pageIndex, pageSize: this.pagesize, ...this.searchModel }).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.dataList = data.list;
          this.total = data.total;
        } else {
          this.$message({
            message: message,
            type: "error",
          });
        }
      });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.pageIndex = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    //查看借还记录
    viewLend(row) {
      this.lendForm = {};
      this.lendShow = true;
      mktBorrowViewDetail(row.id).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          // 处理图片URL数组
          if (data.prePhotoUrls && Array.isArray(data.prePhotoUrls)) {
            data.prePhotoUrls = data.prePhotoUrls.map(url => this.getFullUrl(url))
          }
          if (data.photoUrls && Array.isArray(data.photoUrls)) {
            data.photoUrls = data.photoUrls.map(url => this.getFullUrl(url))
          }
          this.lendForm = data;
        } else {
          this.$message({
            message: message,
            type: "error",
          });
        }
      });
    },
    //领用确认
    receiptConfirm(row) {
      mktBorrowConfirmView(row.id).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.receiptForm = data;
          this.receiptShow = true;
        } else {
          this.$message({
            message: message,
            type: "error",
          });
        }
      });
    },
    //领用确认保存
    confirmOk() { },

    // 查看使用记录
    viewUsageRecord(row) {
      this.usageRecordRow = row;
      this.usageRecordList = [];
      // 获取借用记录ID和设备ID
      const borrowId = row.id;
      const deviceId = row.deviceId || row.id;
      mktUsageRecordListByBorrowId({ borrowId, deviceId }).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.usageRecordList = data || [];
          this.usageRecordShow = true;
        } else {
          this.$message({
            message: message || "获取使用记录失败",
            type: "error",
          });
        }
      });
    },
    // 显示新增使用记录弹窗
    showAddUsageRecord() {
      this.usageRecordForm = {
        borrowId: this.usageRecordRow.id,
        deviceId: this.usageRecordRow.deviceId || this.usageRecordRow.id,
        deviceCode: this.usageRecordRow.deviceCode || '',
        deviceName: this.usageRecordRow.deviceName || this.usageRecordRow.deviceNames || '',
        useDate: '',
        startTime: '',
        endTime: '',
        sampleName: '',
        sampleCode: '',
        statusBeforeUse: null,
        statusAfterUse: null,
        remark: ''
      };
      this.addUsageRecordShow = true;
    },
    // 提交使用记录
    submitUsageRecord() {
      if (!this.usageRecordForm.useDate) {
        this.$message({ message: "请选择使用日期", type: "warning" });
        return;
      }
      if (!this.usageRecordForm.startTime) {
        this.$message({ message: "请选择开始时间", type: "warning" });
        return;
      }
      if (!this.usageRecordForm.endTime) {
        this.$message({ message: "请选择结束时间", type: "warning" });
        return;
      }
      if (this.usageRecordForm.endTime <= this.usageRecordForm.startTime) {
        this.$message({ message: "结束时间不能小于开始时间", type: "warning" });
        return;
      }
      if (!this.usageRecordForm.statusBeforeUse) {
        this.$message({ message: "请选择使用前状态", type: "warning" });
        return;
      }
      if (!this.usageRecordForm.statusAfterUse) {
        this.$message({ message: "请选择使用后状态", type: "warning" });
        return;
      }
      mktUsageRecordAdd(this.usageRecordForm).then((datas) => {
        let { status, message } = datas;
        if (status == 200) {
          this.$message({ message: "保存成功", type: "success" });
          this.addUsageRecordShow = false;
          this.viewUsageRecord(this.usageRecordRow);
        } else {
          this.$message({ message: message || "保存失败", type: "error" });
        }
      });
    },
    // 删除使用记录
    deleteUsageRecord(id) {
      this.$confirm("确定删除该使用记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        mktUsageRecordDelete(id).then((datas) => {
          let { status, message } = datas;
          if (status == 200) {
            this.$message({ message: "删除成功", type: "success" });
            this.viewUsageRecord(this.usageRecordRow);
          } else {
            this.$message({ message: message || "删除失败", type: "error" });
          }
        });
      });
    },
    // 导出使用记录
    exportUsageRecord() {
      const borrowId = this.usageRecordRow.id;
      const deviceId = this.usageRecordRow.deviceId || this.usageRecordRow.id;
      mktUsageRecordExport({ borrowId, deviceId }).then((res) => {
        if (res.status === 200) {
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = '设备使用记录.docx';
          link.click();
          window.URL.revokeObjectURL(url);
          this.$message({ message: "导出成功", type: "success" });
        } else {
          this.$message({ message: "导出失败", type: "error" });
        }
      });
    },
    // 导出维护记录
    exportMaintenanceRecord() {
      const borrowId = this.maintenanceRecordRow.id;
      const deviceId = this.maintenanceRecordRow.deviceId || this.maintenanceRecordRow.id;
      mktMaintenanceRecordExport({ borrowId, deviceId }).then((res) => {
        if (res.status === 200) {
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = '设备维护记录.docx';
          link.click();
          window.URL.revokeObjectURL(url);
          this.$message({ message: "导出成功", type: "success" });
        } else {
          this.$message({ message: "导出失败", type: "error" });
        }
      });
    },

    // 查看维护记录
    viewMaintenanceRecord(row) {
      this.maintenanceRecordRow = row;
      this.maintenanceDeviceName = row.deviceName || row.deviceNames || '';
      this.maintenanceRecordList = [];
      // 获取借用记录ID和设备ID
      const borrowId = row.id;
      const deviceId = row.deviceId || row.id;
      mktMaintenanceRecordListByDeviceId(borrowId, deviceId).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.maintenanceRecordList = (data && data.list) ? data.list : [];
          this.maintenanceRecordShow = true;
        } else {
          this.$message({
            message: message || "获取维护记录失败",
            type: "error",
          });
        }
      });
    },
    // 显示新增维护记录弹窗
    showAddMaintenanceRecord() {
      this.maintenanceRecordForm = {
        borrowId: this.maintenanceRecordRow.id,
        deviceId: this.maintenanceRecordRow.deviceId || this.maintenanceRecordRow.id,
        maintenanceTime: '',
        maintenanceContent: '',
        remark: ''
      };
      this.addMaintenanceRecordShow = true;
    },
    // 提交维护记录
    submitMaintenanceRecord() {
      if (!this.maintenanceRecordForm.maintenanceTime) {
        this.$message({ message: "请选择维护日期", type: "warning" });
        return;
      }
      if (!this.maintenanceRecordForm.maintenanceContent) {
        this.$message({ message: "请输入维护内容", type: "warning" });
        return;
      }
      mktMaintenanceRecordAdd(this.maintenanceRecordForm).then((datas) => {
        let { status, message } = datas;
        if (status == 200) {
          this.$message({ message: "保存成功", type: "success" });
          this.addMaintenanceRecordShow = false;
          this.viewMaintenanceRecord(this.maintenanceRecordRow);
        } else {
          this.$message({ message: message || "保存失败", type: "error" });
        }
      });
    },
    // 删除维护记录
    deleteMaintenanceRecord(id) {
      this.$confirm("确定删除该维护记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        mktMaintenanceRecordDelete(id).then((datas) => {
          let { status, message } = datas;
          if (status == 200) {
            this.$message({ message: "删除成功", type: "success" });
            this.viewMaintenanceRecord(this.maintenanceRecordRow);
          } else {
            this.$message({ message: message || "删除失败", type: "error" });
          }
        });
      });
    },

    selectClick(row) {
      mktBorrowView(row.id).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.viewShow = true;
          this.viewForm = data;
        } else {
          this.$message({
            message: message,
            type: "error",
          });
        }
      });
    },
    searchDeviceinfo() {
      this.getList();
    },
    getRowKeys(row) {
      return row.id;
    },
    //删除借用记录
    clickDeleteBtn(id) {
      this.$confirm("确定删除该记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        mktBorrowDelete({ id }).then((datas) => {
          let { status, message, data } = datas;
          if (status == 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: "删除失败：" + message,
              type: "error",
            });
          }
        });
      });
    },

    // 编辑草稿：跳转到 Market 页面，Market 页面会自动打开编辑弹窗
    editDraftBtn(row) {
      sessionStorage.setItem("editBorrowDraftId", row.id);
      this.$router.push({ path: "/Market" });
    },

    // 提交草稿（草稿→待审核，锁定设备）
    submitDraftBtn(row) {
      this.$confirm(
        `确认提交【${row.projectName || "该申请"}】？提交后设备将被锁定。`,
        "提示",
        {
          confirmButtonText: "确认提交",
          cancelButtonText: "再想想",
          type: "warning",
        }
      ).then(() => {
        mktBorrowSubmit({ id: row.id }).then((datas) => {
          let { status, message } = datas;
          if (status == 200) {
            this.$message({ message: "提交成功", type: "success" });
            this.getList();
          } else {
            this.$message({ message: message || "提交失败", type: "error" });
          }
        });
      }).catch(() => {});
    },

    // 撤回申请（待审核→草稿，释放设备）
    cancelBorrowBtn(row) {
      this.$confirm(
        `确认撤回【${row.projectName || "该申请"}】？撤回后设备将被释放。`,
        "提示",
        {
          confirmButtonText: "确认撤回",
          cancelButtonText: "再想想",
          type: "warning",
        }
      ).then(() => {
        mktBorrowCancel({ id: row.id }).then((datas) => {
          let { status, message } = datas;
          if (status == 200) {
            this.$message({ message: "撤回成功", type: "success" });
            this.getList();
          } else {
            this.$message({ message: message || "撤回失败", type: "error" });
          }
        });
      }).catch(() => {});
    },

    // 删除草稿
    deleteDraftBtn(row) {
      this.$confirm(
        `确认删除【${row.projectName || "该草稿"}】？删除后无法恢复。`,
        "提示",
        {
          confirmButtonText: "确认删除",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        mktBorrowDeleteDraft({ id: row.id }).then((datas) => {
          let { status, message } = datas;
          if (status == 200) {
            this.$message({ message: "删除成功", type: "success" });
            this.getList();
          } else {
            this.$message({ message: message || "删除失败", type: "error" });
          }
        });
      }).catch(() => {});
    },
  },
  created() {
    let userinfo = JSON.parse(localStorage.getItem("user"));
    this.btnRole = userinfo.role.menuId.split(",");
    this.getList();
  },
};
</script>
<style scoped>
.btn {
  float: left;
}

.statueBtn {
  padding: 10px 10px;
  border: 0px;
  float: left;
  margin-left: 10px;
}

.statueSpan {
  vertical-align: middle;
  float: left;
  margin-left: 5px;
}

/* .el-input__inner{
    height:40px!important
} */
</style>
<style>
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style lang="less" scoped>
#deviceTable {
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 16px;
    /*滚动条宽度*/
    height: 16px;
    /*滚动条高度*/
    margin-top: 100px;
  }

  /* 给固定列设置下边距 */
  /deep/ .el-table__fixed {
    height: auto !important;
    bottom: 15px !important;
    /* 具体值是多少根据你横向滚动条的高度进行设置 */
  }

  /deep/ .el-table__fixed-left {
    height: 100% !important;
  }

  /* 去掉固定列下方的横线 */
  /deep/ .el-table__fixed::before,
  .el-table__fixed-left::before {
    display: none;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #ededed;
  }

  /*定义滑块 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #cfcbcb;
  }

  /deep/ .el-table__fixed-body-wrapper {
    height: calc(100% -57px) !important;
    padding-bottom: 17px;
    box-sizing: content-box;
  }

  /deep/ .tr-diaobo {
    color: red !important;
  }

  /deep/ .tr-baofei {
    color: #580fda !important;
  }

  /deep/ .tr-jiandin {
    color: #f4de5c !important;
  }
}

.el-table--border {
  border-color: #000000 !important;
  width: 320px;
  border-right: 1px solid #000000 !important;
  border-bottom: 1px solid #000000 !important;
}

#table /deep/ .cell {
  padding-left: 2px !important;
  padding-right: 0px !important;
}

.docx-wrapper {
  background: white !important;
  padding: 10px;
}

.docx {
  padding: 0pt 20.65pt 20pt 20.55pt !important;
  width: 789.9pt !important;
  min-height: 0px !important;
  margin-top: -30px !important;
  margin-left: -10px !important;
}

/deep/ .el-descriptions-item__label {
  width: 15% !important;
  text-align: right;
}

/deep/ .el-descriptions-item__content {
  width: 35% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/market/Record.vue